import pages from './pages'
import home from './home/home-routing'
import about from './about/about-routing'
import roleManage from './roleManage/roleManage-routing'
import empManage from './empManage/empManage-routing'
import safe from './safe/safe-routing'
import lysafe from './leyousafe/safe-routing'
import account from './account/routing'
import popAgreement from './popAgreement/popAgreement-routing'
import enter from './enter/enetr-routing'
import level2 from './level2/routing'
import comment from './comment/routing'
import article from './article/routing'
import canvass from './canvass/canvass-routing'
import adwords from './adwords/adwords-routing'
import mobile from './mobile/mobile-routing'
import advertiser from './advertiser/routing'
import leyouAccount from './leyouAccount/routing'
import lyEmManage from './lyEmManage/empManage-routing'
import lyRoleManage from './lyRoleManage/roleManage-routing'
import { util } from '@utils'

export default [{
    path: '/pages',
    name: 'pages',
    component: pages,
    children:[
        ...home,
        ...about,
        ...popAgreement,
        ...enter,
        ...level2,
        ...comment,
        ...article,
        ...adwords,
        ...canvass,
        ...mobile,
        ...advertiser,
    ]
},
{
    path: '/my',
    name: 'my',
    component: pages,
    redirect: { name: 'safe' },
    beforeEnter: (to, from, next) => {
        const ensureLogin =  util.ensureLogin()
        if(ensureLogin) {
            next();
        }
    },
    children:[
        ...roleManage,
        ...empManage,
        ...safe,
        ...account,
    ]
},
{
    path: '/ly',
    name: 'ly',
    component: pages,
    redirect: { name: 'leyousafe' },
    beforeEnter: (to, from, next) => {
        const ensureLogin =  util.ensureLogin()
        if(ensureLogin) {
            next();
        }
    },
    children:[
        // ...roleManage,
        // ...empManage,
        ...lysafe,
        ...leyouAccount,
        ...lyEmManage,
        ...lyRoleManage,
    ]
},
{
    path: '',
    redirect: { name: 'pages' }
}]
